import React from 'react';
import { CheckCircle2Icon, MailIcon, AlertCircleIcon, PartyPopperIcon, HeartIcon } from 'lucide-react';
const NAVY = '#142D52';
const CORAL = '#F05B56';
const TEAL = '#00AFAA';
const MINT = '#F0FAF9';
export function BedanktAankoopPage() {
  return <div className="min-h-screen w-full font-sans" style={{
    backgroundColor: MINT,
    color: NAVY,
    fontFamily: "'Sen', sans-serif"
  }} data-id="element-591">
      {/* Logo bar */}
      <nav className="w-full bg-white border-b border-gray-100 py-4 px-6" data-id="element-592">
        <div className="max-w-5xl mx-auto flex justify-center" data-id="element-593">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-594" />
        </div>
      </nav>

      {/* Hero */}
      <section className="max-w-3xl mx-auto px-4 pt-12 pb-8 text-center" data-id="element-595">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-6 shadow-lg" style={{
        backgroundColor: TEAL
      }} data-id="element-596">
          <CheckCircle2Icon className="w-12 h-12 text-white" strokeWidth={2.5} data-id="element-597" />
        </div>
        <p className="text-sm font-bold uppercase tracking-widest mb-3" style={{
        color: CORAL
      }} data-id="element-598">
          Aankoop geslaagd
        </p>
        <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-4 flex items-center justify-center gap-3 flex-wrap" style={{
        color: NAVY
      }} data-id="element-599">
          Yes! Gefeliciteerd
          <PartyPopperIcon className="w-9 h-9 md:w-11 md:h-11" style={{
          color: CORAL
        }} data-id="element-600" />
        </h1>
        <p className="text-xl md:text-2xl font-medium mb-2" style={{
        color: NAVY
      }} data-id="element-601">
          Je aankoop is geslaagd
        </p>
      </section>

      {/* Personal message from Amee */}
      <section className="max-w-3xl mx-auto px-4 pb-10" data-id="element-602">
        <div className="bg-white rounded-2xl shadow-md p-6 md:p-10" data-id="element-603">
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5 mb-6" data-id="element-604">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover flex-shrink-0 ring-4 ring-white shadow-md" data-id="element-605" />
            <div className="text-center sm:text-left" data-id="element-606">
              <p className="font-bold text-lg" style={{
              color: NAVY
            }} data-id="element-607">
                Een persoonlijk berichtje van Amee
              </p>
              <p className="text-gray-500 text-sm" data-id="element-608">Oprichter Stressless Dogs</p>
            </div>
          </div>

          <div className="text-base md:text-lg leading-relaxed space-y-4" style={{
          color: NAVY
        }} data-id="element-609">
            <p data-id="element-610">Wauw, wat ben ik blij dat je deze stap zet! 🙌</p>
            <p data-id="element-611">
              Wat ontzettend goed dat je investeert in het{' '}
              <span className="font-bold" data-id="element-612">geluk van je hond</span> en in jullie
              onderlinge band - daar mag je als hondeneigenaar écht trots op
              zijn.
            </p>
            <p className="italic font-medium" style={{
            color: CORAL
          }} data-id="element-613">
              *applausje voor jezelf* 👏
            </p>
            <p data-id="element-614">
              De meeste baasjes blijven hangen in oude trainingen en commando's.
              Jij kiest voor iets anders: écht communiceren met je hond. En dat
              is precies waar de mooiste banden ontstaan.
            </p>
            <p className="flex items-center gap-2 font-semibold" data-id="element-615">
              Liefs, Amee{' '}
              <HeartIcon className="w-5 h-5" style={{
              color: CORAL,
              fill: CORAL
            }} data-id="element-616" />
            </p>
          </div>
        </div>
      </section>

      {/* Next steps */}
      <section className="max-w-3xl mx-auto px-4 pb-10" data-id="element-617">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center" style={{
        color: NAVY
      }} data-id="element-618">
          Wat gebeurt er nu?
        </h2>

        <div className="space-y-4" data-id="element-619">
          {/* Step 1 */}
          <div className="bg-white rounded-2xl shadow-sm p-5 md:p-6 flex gap-4 items-start" data-id="element-620">
            <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg" style={{
            backgroundColor: TEAL
          }} data-id="element-621">
              <MailIcon className="w-6 h-6" data-id="element-622" />
            </div>
            <div className="flex-1" data-id="element-623">
              <p className="font-bold text-lg mb-1" style={{
              color: NAVY
            }} data-id="element-624">
                Check je mailbox
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-625">
                Binnen enkele minuten ontvang je een bevestigingsmail met je{' '}
                <span className="font-semibold" data-id="element-626">inloggegevens</span> en alle
                informatie om direct te kunnen starten.
              </p>
            </div>
          </div>

          {/* Step 2 - warning */}
          <div className="rounded-2xl p-5 md:p-6 flex gap-4 items-start border-2" style={{
          backgroundColor: '#FFF7ED',
          borderColor: CORAL
        }} data-id="element-627">
            <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white" style={{
            backgroundColor: CORAL
          }} data-id="element-628">
              <AlertCircleIcon className="w-6 h-6" data-id="element-629" />
            </div>
            <div className="flex-1" data-id="element-630">
              <p className="font-bold text-lg mb-1" style={{
              color: NAVY
            }} data-id="element-631">
                Belangrijk: niets ontvangen na 10 minuten?
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-632">
                Check dan even je{' '}
                <span className="font-semibold" data-id="element-633">spam- of reclamefolder</span>.
                Mailtjes belanden daar soms onbedoeld in.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Support */}
      <section className="max-w-3xl mx-auto px-4 pb-16" data-id="element-634">
        <div className="rounded-2xl p-6 md:p-8 text-center" style={{
        backgroundColor: NAVY
      }} data-id="element-635">
          <p className="text-white/80 mb-2 text-sm uppercase tracking-wider font-semibold" data-id="element-636">
            Hulp nodig?
          </p>
          <h3 className="text-white text-xl md:text-2xl font-bold mb-3" data-id="element-637">
            Vragen of technische problemen?
          </h3>
          <p className="text-white/90 mb-5 leading-relaxed" data-id="element-638">
            Stuur me gerust een mailtje - ik help je graag persoonlijk verder.
          </p>
          <a href="mailto:Amee@Stresslessdogs.nl" className="inline-flex items-center gap-2 bg-white font-bold px-6 py-3 rounded-full transition-transform hover:scale-105 shadow-lg" style={{
          color: NAVY
        }} data-id="element-639">
            <MailIcon className="w-5 h-5" data-id="element-640" />
            Amee@Stresslessdogs.nl
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white py-8 px-4" data-id="element-641">
        <div className="max-w-5xl mx-auto text-center text-sm text-gray-500" data-id="element-642">
          <p data-id="element-643">© 2025 Stressless Dogs. Voor liefdevolle hondenbaasjes.</p>
        </div>
      </footer>
    </div>;
}